import { AsyncPropSelector } from '@nile/components';
import { Popover, Button, ButtonGroup } from '@superops/ui-design-system';
import { Edit } from '@styled-icons/material/Edit';
import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
import { DisabledTag } from '../../Pebbles/TicketContainer';
import { EditIcon } from '@nile/components/src/Icons';

const StyledTag = styled.div`
  background: #e3edff;
  padding: 2px 10px;
  border-radius: 4px;
  text-transform: uppercase;
  font-weight: 500;
`;

const Wrap = styled.div`
  display: flex;
  align-items: center;
  .edit-actions {
    visibility: hidden;
    cursor: pointer;
  }
`;

const Field = styled.div`
  min-width: 200px;
  max-width: 250px;
  flex-grow: 1;
  padding-right: 10px;
  padding-left: 10px;
  margin-top: 8px;
  margin-bottom: 8px;
  .Polaris-ButtonGroup {
    margin-top: 12px;
  }
`;


function TagCell(props) {
  const { cell } = props;
  const { editable, field, actions } = cell.column;
  const ticket = cell.row.original;
  const [popoverActive, setPopoverActive] = useState(false);
  const [updatedProperties, setUpdatedProperties] = useState({});
  const togglePopoverActive = useCallback(() => {
    setPopoverActive(!popoverActive);
  });

  const activator = <EditIcon onClick={() => togglePopoverActive()} />;

  const updateSelectedProperties = (key, value) => {
    setUpdatedProperties({
      ...updatedProperties,
      [key]: value
    });
  };

  const updateSelection = (f, val) => {
    let serialisedValue = null;
    if (field.isCustom) {
      updateSelectedProperties('customFields', val);
    } else {
      switch (field.name) {
        case 'techGroup':
          serialisedValue = { groupId: val.groupId, name: val.name };
          break;
        case 'technician':
          serialisedValue = { userId: val.userId };
          break;
        default:
          serialisedValue = val.name;
      }
      updateSelectedProperties(field.name, serialisedValue);
    }
  };

  const getTag = () => {
    const fieldValue = updatedProperties[field.name] || ticket[field.name];
    const defaultValue = fieldValue
      ? { name: fieldValue, label: fieldValue, value: fieldValue }
      : '';
    return (
      <Field>
        <AsyncPropSelector
          defaultValue={defaultValue}
          updateSelection={updateSelection}
          ticket={ticket}
          field={field}
        />
        <div className="mt10">
          <ButtonGroup>
            <Button
              onClick={() => {
                togglePopoverActive();
                setUpdatedProperties({});
              }}
            >
              Cancel
            </Button>
            <Button
              primary
              onClick={() => {
                actions.save &&
                  actions.save(updatedProperties, ticket, props.data);
                togglePopoverActive();
                setUpdatedProperties({});
              }}
            >
              Save
            </Button>
          </ButtonGroup>
        </div>
      </Field>
    );
  };
  return !popoverActive ? (
    <Wrap className={`${editable ? 'editable-cell' : ''}`}>
      {cell.value ? (
        <StyledTag>{cell.value}</StyledTag>
      ) : (
        <DisabledTag>NA</DisabledTag>
      )}
      {editable && <div className="edit-actions">{activator}</div>}
    </Wrap>
  ) : (
    <Wrap>
      {cell.value ? (
        <StyledTag>{cell.value}</StyledTag>
      ) : (
        <DisabledTag>NA</DisabledTag>
      )}
      <Popover
        activator={activator}
        active={popoverActive}
        onClose={() => {
          //debugger;
          return;
          togglePopoverActive();
        }}
      >
        {getTag()}
      </Popover>
    </Wrap>
  );
}

export default TagCell;
